module.exports = __webpack_public_path__ + "img/robot_gif3.fb9d8d3e.fb9d8d3e.gif";